/*
  Najah Wishlist
  Browser-based wishlist shared by product cards, the wishlist page,
  and the header count. Data is stored in localStorage on this device.
*/
(function () {
  'use strict';

  if (window.NajahWishlist && window.NajahWishlist.version) {
    window.NajahWishlist.refresh();
    return;
  }

  var STORAGE_KEY = 'najah_wishlist_v1';
  var READY_EVENT = 'najah:wishlist:ready';
  var CHANGE_EVENT = 'najah:wishlist:change';
  var MAX_ITEMS = 100;

  function normaliseHandle(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normaliseList(value) {
    if (!Array.isArray(value)) return [];

    var seen = Object.create(null);
    var result = [];

    value.forEach(function (item) {
      var handle = normaliseHandle(item);

      if (!handle || seen[handle] || result.length >= MAX_ITEMS) return;

      seen[handle] = true;
      result.push(handle);
    });

    return result;
  }

  function read() {
    try {
      return normaliseList(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch (error) {
      return [];
    }
  }

  function emit(action, handle, items) {
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, {
      bubbles: true,
      detail: {
        action: action || 'sync',
        handle: handle || '',
        items: items.slice(),
        count: items.length
      }
    }));
  }

  function write(items, options) {
    var nextItems = normaliseList(items);
    var settings = options || {};

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(nextItems));
    } catch (error) {}

    refresh();

    if (!settings.silent) {
      emit(settings.action || 'set', settings.handle || '', nextItems);
    }

    return nextItems;
  }

  function has(handle) {
    var cleanHandle = normaliseHandle(handle);
    return cleanHandle ? read().indexOf(cleanHandle) > -1 : false;
  }

  function add(handle) {
    var cleanHandle = normaliseHandle(handle);
    if (!cleanHandle) return read();

    var items = read();

    if (items.indexOf(cleanHandle) === -1) {
      items.push(cleanHandle);
    }

    return write(items, {
      action: 'add',
      handle: cleanHandle
    });
  }

  function remove(handle) {
    var cleanHandle = normaliseHandle(handle);
    var items = read().filter(function (item) {
      return item !== cleanHandle;
    });

    return write(items, {
      action: 'remove',
      handle: cleanHandle
    });
  }

  function toggle(handle) {
    var cleanHandle = normaliseHandle(handle);

    if (!cleanHandle) {
      return {
        active: false,
        items: read()
      };
    }

    var active = has(cleanHandle);
    var items = active ? remove(cleanHandle) : add(cleanHandle);

    return {
      active: !active,
      items: items
    };
  }

  function syncButton(button, items) {
    var handle = normaliseHandle(button.getAttribute('data-product-handle'));
    var active = handle && items.indexOf(handle) > -1;
    var addLabel = button.getAttribute('data-wishlist-add-label') || 'Add to wishlist';
    var removeLabel = button.getAttribute('data-wishlist-remove-label') || 'Remove from wishlist';

    button.classList.toggle('is-active', Boolean(active));
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? removeLabel : addLabel);
    button.setAttribute('title', active ? removeLabel : addLabel);
  }

  function syncCount(element, count) {
    element.textContent = String(count);
    element.setAttribute('aria-label', count + (count === 1 ? ' item in wishlist' : ' items in wishlist'));
    element.classList.toggle('is-empty', count === 0);
  }

  function refresh(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = read();

    scope.querySelectorAll('[data-najah-wishlist-toggle]').forEach(function (button) {
      syncButton(button, items);
    });

    document.querySelectorAll('[data-najah-wishlist-count]').forEach(function (element) {
      syncCount(element, items.length);
    });

    return items;
  }

  function handleWishlistClick(event) {
    var button = event.target.closest('[data-najah-wishlist-toggle]');
    if (!button) return;

    var handle = normaliseHandle(button.getAttribute('data-product-handle'));
    if (!handle) return;

    event.preventDefault();
    event.stopPropagation();

    var result = toggle(handle);

    if (typeof button.animate === 'function') {
      button.animate(
        [
          { transform: 'scale(1)' },
          { transform: 'scale(1.16)' },
          { transform: 'scale(1)' }
        ],
        {
          duration: 260,
          easing: 'cubic-bezier(.2,.8,.2,1)'
        }
      );
    }

    syncButton(button, result.items);
  }

  document.addEventListener('click', handleWishlistClick);

  document.addEventListener('DOMContentLoaded', function () {
    refresh();
  });

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;

    var items = refresh();
    emit('storage', '', items);
  });

  window.NajahWishlist = {
    version: '1.0.0',
    key: STORAGE_KEY,
    get: read,
    set: write,
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    count: function () {
      return read().length;
    },
    refresh: refresh
  };

  refresh();

  document.dispatchEvent(new CustomEvent(READY_EVENT, {
    detail: {
      count: read().length
    }
  }));
})();
